<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      clipped
      floating
      app
      :permanent="$vuetify.breakpoint.mdAndUp"
      :mini-variant.sync="mini"
      mini-variant-width="75"
      width="205"
      color="ice"
      class="mt-md-12"
    >
      <v-list flat>
        <v-list-item-group>
          <v-list-item class="justify-start pl-6" :ripple="false">
            <v-list-item-action
              v-if="mini"
              @click.stop="toggleDrawer"
              id="idAbrirMenu"
            >
              <v-icon v-if="mini">mdi-menu</v-icon>
            </v-list-item-action>
            <v-list-item-action
              v-else
              @click.stop="toggleDrawer"
              id="idCerrarMenu"
            >
              <v-icon>mdi-close</v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            v-for="item in navItems"
            :key="item.text"
            :id="item.id"
            class="justify-start pl-6"
            color="primary"
            :ripple="false"
            link
            exact
            @click="routerLink(item)"
          >
            <v-list-item-action :class="{ 'pb-1': item.id === 'idEtiquetas' }">
              <SvgIcon class="drawer-icon" :iconType="item.icon" />
            </v-list-item-action>
            <v-list-item-content class="overflow-visible">
              <v-list-item-title
                class="overflow-visible"
                style="white-space: normal;"
              >
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      app
      color="white darken-3"
      height="75"
      elevation="0"
      class="pl-0"
    >
      <div
        v-if="$vuetify.breakpoint.smAndDown"
        class="app-icon secondary toggler d-flex align-center justify-center"
        style="background: #e9ecf0 !important"
      >
        <v-btn icon @click.stop="toggleDrawer">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </div>
      <div
        class="app-icon d-flex align-center justify-center"
        :class="[
          appColor,
          $vuetify.breakpoint.smAndDown ? 'menu-icon-active' : ''
        ]"
      >
        <SvgIcon
          width="50"
          height="50"
          class="white--text"
          :iconType="appIcon"
        />
      </div>
      <v-toolbar-title
        v-if="appNameToShow !== '' && $vuetify.breakpoint.mdAndUp"
        class="font-weight-bold"
        >{{ appNameToShow }}</v-toolbar-title
      >

      <v-spacer />
      <div
        class="mr-4"
        style="position: relative"
        v-click-outside="onClickOutsideToolBarAppBox"
      >
        <v-btn
          id="idBentoMenu"
          height="35"
          width="35"
          icon
          color="grey darken-3"
          small
          class="white"
          :loading="toolbarAppBoxLoading"
          @click="toggleToolbarAppBox"
        >
          <SvgIcon
            width="24"
            height="24"
            iconType="icon_menu_opener"
            :class="toolbarAppBoxState ? 'primary--text' : 'secondary--text'"
            style="position: relative; top: -1px"
          />
        </v-btn>
        <ToolbarAppBox
          id="toolBarAppBox"
          class="rounded-lg py-4 white px-6 elevation-6"
          v-if="showToolBarAppBox"
          :services="services"
        />
      </div>

      <span class="d-none d-sm-inline secondary--text mr-1">
        {{ userFullName }}</span
      >

      <MenuServicesAndProducts
        :show-invoice="showInvoice"
        :toggle-help-center-box="toggleHelpCenterBox"
        :avatar-image="user.avatarImage"
      />
      <div style="position: relative">
        <HelpCenterAppBox
          id="helpCenterAppBoxFM"
          v-if="helpCenterStatus"
          class="elevation-6 mx-6 rounded-lg"
          v-click-outside="closeHelpCenterBox"
        />
      </div>
      <v-alert class="test" :value="alert" dismissible type="error"
        >No se pudo realizar el logout</v-alert
      >
    </v-app-bar>
  </div>
</template>

<script>
import { SvgIcon, firebaseServices } from '@leapsight/styleguide'
import ToolbarAppBox from './ToolbarAppBox'
import HelpCenterAppBox from '@/components/HelpCenterAppBox.vue'
import { UiHelpers } from '@/helpers/mainExports'
import i18n from '@/plugins/i18n'
import { getMountedApps } from 'single-spa'
import firebaseTagNames from '@/constants/firebaseTagNames'
import MenuServicesAndProducts from '@/components/MenuServicesAndProducts.vue'

export default {
  name: 'DrawerToolbar',
  components: {
    MenuServicesAndProducts,
    SvgIcon,
    ToolbarAppBox,
    HelpCenterAppBox
  },
  props: {
    navItems: {
      type: Array,
      required: true
    },
    user: {
      type: Object
    },
    showInvoice: {
      type: Function,
      default: () => ({})
    }
  },
  data() {
    return {
      dialog: false,
      drawer: null,
      mini: true,
      alert: false,
      logoutLoading: false,
      showToolBarAppBox: false,
      toolbarAppBoxLoading: false,
      appColor: '',
      appIcon: '',
      appNameToShow: '',
      services: [],
      helpCenterStatus: false
    }
  },
  methods: {
    toggleHelpCenterBox() {
      this.helpCenterStatus = !this.helpCenterStatus
    },
    routerLink(item) {
      this.$router.push(item.to).then(() => {
        item?.logEvent ? item.logEvent() : null
      })
    },
    toggleDrawer() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.mini = !this.mini
      } else {
        this.mini = false
        this.drawer = !this.drawer
      }
    },
    toggleToolbarAppBox() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        firebaseTagNames.BTN_PORTAL_HEADER_NINE_CIRCLE_MENU
      )
      if (!this.showToolBarAppBox) {
        this.toolbarAppBoxLoading = true

        UiHelpers.getAccountServices().then(response => {
          this.services = response
          this.services[0]['domElementId'] = 'idBentoMenuAdministracion'
          this.services[1]['domElementId'] = 'idBentoMenuMonitoreo'
          this.services[2]['domElementId'] = 'idBentoMenuInformes'

          this.toolbarAppBoxLoading = false
          this.showToolBarAppBox = !this.showToolBarAppBox
        })
      } else this.showToolBarAppBox = false
    },
    onClickOutsideToolBarAppBox() {
      this.showToolBarAppBox = false
    },
    getAppMounted() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const mainThis = this
      //El timeout da tiempo de resolución de aplicación montada a singleSpa cuando cambiamos de app
      setTimeout(() => {
        const apps = getMountedApps()
        const appName = apps[0].split('/')[1]
        switch (appName) {
          case 'live-tracking':
            mainThis.appColor = 'primary__dark'
            mainThis.appIcon = 'icon_live_tracking'
            break
          case 'fleet-management':
            mainThis.appColor = 'secondary'
            mainThis.appIcon = 'icon_fleet_management'
            mainThis.appNameToShow = i18n.t('general.apps.fleet_management')
            break
          case 'portal':
            mainThis.appColor = 'primary'
            mainThis.appIcon = 'icon_s_logo'
            break
          case 'reports':
            mainThis.appColor = 'reports'
            mainThis.appIcon = 'icon_reports'
            mainThis.appNameToShow = i18n.t(
              'portal.general.app_list.labels.apps.reports'
            )
            break
          default:
            break
        }
      }, 100)
    },
    onUpdateUserData(e) {
      this.user = e.detail
    },
    closeHelpCenterBox() {
      this.helpCenterStatus = false
    }
  },
  computed: {
    userFullName() {
      const firstName = this.user?.name
      const lastName = this.user?.last_name
      if (
        (typeof firstName !== 'undefined') &
        (typeof lastName !== 'undefined')
      ) {
        return `${firstName} ${lastName}`
      } else {
        return ''
      }
    }
  },
  mounted() {
    this.getAppMounted()
    window.addEventListener('update-people-data', this.onUpdateUserData)
  },
  destroyed() {
    window.removeEventListener('update-people-data', this.onUpdateUserData)
  }
}
</script>

<style scoped>
#toolBarAppBox {
  position: absolute;
  z-index: 10;
  top: 50px;
  right: -12px;
  border: 1px solid #d5d5d5 !important;
}
.app-icon {
  width: 75px;
  position: absolute;
  left: 0;
  z-index: 10;
  height: 100%;
}
.app-icon .menu-icon-active {
  left: 75px;
}

.strix_logo svg {
  display: block;
  width: 1em;
  height: 1em;
}
.strix_logo svg {
  fill: #000 !important;
}
.drawer-icon {
  width: 24px;
  height: 24px;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: var(--flat-blue-dark) !important;
}
.v-toolbar__title {
  position: absolute;
  left: 99px;
  font-size: 1.375rem;
}
</style>
